import { gql } from "@apollo/client";

export const GetAllUserQuery = gql `
query{
    getAllUser {
      response
    }
}
`;

export const isLoginCheckQuery = gql `
query($deviceId: String!){
  IsLogin(deviceId: $deviceId) {
    isLogin
  }
}
`;


export const GetUserByEmpIdQuery = gql `
query($employeeId: String!){
  getUserByEmpId(employeeId: $employeeId) {
    response
  }
}
`;


export const ForgetUserPasswordMutation = gql`
  mutation($email: String!, $employeeId: String!) {
    forgetUserPassword(email: $email, employeeId: $employeeId) {
      message
    }
  }
`;
// Can this email be this person's login? An email used anywhere on WFC360 (any company's login,
// anyone else's own employee email) never can. Never says who has it.
export const IsEmailAvailableQuery = gql `
query($email: String!, $employeeId: String, $userId: String){
  isEmailAvailable(email: $email, employeeId: $employeeId, userId: $userId)
}
`;

// The join page (invite or "forgot password" link): who the link is for, if it's still good
export const PasswordLinkDetailsQuery = gql `
query($employeeId: String!, $token: String!){
  passwordLinkDetails(employeeId: $employeeId, token: $token)
}`;
